<template>
    <div>
        <v-card class="pa-5">
            <v-card-text>
                <v-card-title style="padding: 5px;"><h3>{{$t('general.reportsCatalog')}}</h3></v-card-title>
                <v-divider class="my-0"/>

                <v-card-subtitle><h2>{{$t('general.inspections')}}</h2></v-card-subtitle>
                <v-container fluid class="padding_cero">
                    <v-row no-gutters class="mb-1">
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-0">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/inspectionUnitTypes" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-truck</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.inspectionsByUnitType') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.inspectionsByUnitTypeMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.inspectionsByUnitType') }}</span>
                            </v-tooltip>
                        </v-col>
                        
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-0">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/inspectionReportInspector" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-id-badge</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.inspectionReportInspector') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.inspectionReportInspectorMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.inspectionReportInspector') }}</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mt-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/inspectionCountByUnit" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-clipboard-check</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.inspectionCountByUnit') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.inspectionCountByUnitMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.inspectionCountByUnit') }}</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mt-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/tireChangeReport" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-exchange-alt</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.tireChangeReport') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.tireChangeReportMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.tireChangeReport') }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-subtitle><h2>{{$t('reports.incidentsAndDamages')}}</h2></v-card-subtitle>
                <v-container fluid class="padding_cero">
                    <v-row no-gutters class="mb-1">
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/inspectionsUnitType" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-car-crash</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.incidentUnitType') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.incidentUnitTypeMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.incidentUnitType') }}</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/incidentsInspector" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-user-times</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.incidentsInspector') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.incidentsInspectorMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.incidentsInspector') }}</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/inspectionPointsWithDamages" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-clipboard-list</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.inspectionPointsWithDamages') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.inspectionPointsWithDamagesMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.inspectionPointsWithDamages') }}</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/operatorsWithDamages" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-user-tag</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.operatorsWithDamage') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.operatorsWithDamageMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.operatorsWithDamage') }}</span>
                            </v-tooltip>
                        </v-col>
                        <!-- <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card disabled class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/urlPendiente" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-exclamation-triangle</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.frequencyOfDamagesByUnit') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.frequencyOfDamagesByUnitMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('reports.frequencyOfDamagesByUnit') }}</span>
                            </v-tooltip>
                        </v-col> -->
                    </v-row>
                </v-container>

                <v-card-subtitle><h2>{{$t('reports.checklist')}}</h2></v-card-subtitle>
                <v-container fluid class="padding_cero">
                    <v-row no-gutters class="mb-1">
                        <v-col cols="6" sm="6" md="6" class="pr-md-3 mb-4 mb-md-4">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card class="pa-4 elevation-2 rounded-lg card-zoom-effect" to="/reports/checklistReport" v-bind="attrs" v-on="on">
                                        <v-row align="center">
                                            <v-col cols="2" class="d-flex justify-center">
                                                <v-icon large color="primary">fas fa-list-ul</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <h2 class="text-h5 font-weight-bold">{{ $t('reports.checklistReport') }}</h2>
                                                <h4 class="subtitle-1 font-weight-medium text--secondary">{{ $t('reports.checklistReportMessage') }}</h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                                <span>{{ $t('general.clickMessage') }} {{ $t('general.of') }} {{ $t('reports.checklist') }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>
  
<script>
  export default {
    name: 'reportsComponent',
    data () {
      return {
        
      }
    },
    created () {
      
    },
    methods:{
     
    }
  }
</script>

<style scoped>
    .padding_cero {
        padding-bottom: 0px; 
        padding-top: 0px;
    }
</style>